import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useDeleteDeclaration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (declarationId: string) => {
      const result = await apiClient.declarationsCrud.deleteDeclaration.mutation({
        params: { id: declarationId },
      });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarations'] });
      queryClient.invalidateQueries({ queryKey: ['declarations-meta'] });
      toast.success('Successfully deleted the declaration!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error deleting the declaration!');
    },
  });
};
